'use strict';

var _ = require('lodash');
function AppliedAlertScoresTooltipFactory() {
  var HIDE_DELAY = 50;
  function AppliedAlertScoresTooltip() {}
  AppliedAlertScoresTooltip.prototype.getBuilder = function () {
    return builder;
  };
  function builder(cellData, wholeGridData) {
    if (!cellData.value) {
      return '';
    }
    return {
      htmlContent: getHtmlContent(cellData, wholeGridData),
      hideDelay: HIDE_DELAY,
      placement: 'top'
    };
  }
  function getHtmlContent(celldata, wholeGridData) {
    var rowData = wholeGridData[celldata.row];
    var tooltipContent = _.template(require('../templates/applied-alert-scores-tooltip.html'));
    return tooltipContent({
      market: rowData.market,
      alertsData: getAlertsTableData(rowData)
    });
  }
  function getAlertsTableData(row) {
    var alertMaps = [{
      title: 'Missing Fare',
      field: 'fareDefaultingScore'
    }, {
      title: 'Inversion Correction',
      field: 'fareInversionScore'
    }];
    return _.map(alertMaps, function (alertData) {
      return {
        title: alertData.title,
        value: _.get(row, alertData.field, 0)
      };
    });
  }
  return AppliedAlertScoresTooltip;
}
AppliedAlertScoresTooltipFactory.$inject = [];
module.exports = AppliedAlertScoresTooltipFactory;